'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoEmailUnread = function IoEmailUnread(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.5 12.5c0-3.4 1.6-5 5-5s5 1.6 5 5-1.6 5-5 5-5-1.6-5-5z m-11.2 0h10c0 1.3 0.3 2.6 1.1 3.7-0.4 0.2-1.1 0.6-1.7 0.9s-1.2 0.6-1.8 0.9-1.1 0.7-1.7 1-1.2 0.6-1.7 0.8-0.8 0.5-1.2 0.7-0.7 0.4-0.9 0.6-0.4 0.2-0.4 0.2c-0.5 0.3-1 0.3-1.7 0.3s-1.1 0-1.6-0.3c-0.1-0.1-1.2-0.6-3.3-1.8s-4.2-2.2-6.3-3.4-3.4-1.8-3.6-2c-0.6-0.3-1-0.6-1-0.8-0.1-0.3-0.1-0.5 0-0.6s0.5-0.2 0.9-0.2h14.9z m5.3 8.8c1.4-0.8 3.6-2.3 6.5-4.3 1.3 1.1 2.7 1.8 4.4 1.8v12.1c0 0.1-0.1 0.3-0.2 0.5s-0.2 0.4-0.3 0.6-0.4 0.3-0.6 0.3-0.5 0.2-0.6 0.2h-28.9c-0.4 0-0.9-0.2-1.3-0.5s-0.6-0.7-0.6-1.1v-16.1c0-0.4 0.2-0.6 0.7-0.3 0.2 0 0.9 0.5 2 1.3s2.5 1.7 4.2 2.8 3 2 4.1 2.7l-6.5 7.3c-0.1 0.1-0.1 0.3 0 0.4 0.1 0.1 0.3 0.1 0.4-0.1l7.7-6.5c1.2 0.8 1.9 1.3 2.1 1.3 0.5 0.3 1 0.4 1.6 0.4s1.2-0.1 1.7-0.4c0.1 0 0.8-0.5 2.1-1.3l7.6 6.5c0.2 0.2 0.4 0.2 0.5 0.1s0-0.3-0.2-0.4z' })
        )
    );
};

exports.default = IoEmailUnread;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/email-unread.js
// module id = 2016
// module chunks = 0